<template>
  <div>
    <div class="main-wrapper signin-form center">
      <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	    <h3 class="text-align-center margin-bottom-35">Logout</h3>
      <div v-show="login_errors" class="validate-warning-msg-login">{{ login_errors }}</div>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img{ width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import {logout} from 'vuex';
import router from '../router/index.js';
import store from '../store/store.js';

export default {
  data: function () {
    return {
      login_errors: '',
    }
  },
  methods: {
  	navigate(path) {
  	  router.push(path);
  	},
  },
  created() {
    if(this.$store.state.token != '') {
      this.$store.dispatch('logout');
      this.flash({ message: 'You are logged out.', variant: 'success' });
      this.navigate("/mmlogin");
    }
    else {
      this.navigate("/forbidden");
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/logout.vue